import React, { useState, useCallback, useEffect } from 'react';
import { useApiSelect } from "../../api/common/apiSelect";
import { useSelector } from 'react-redux';
import { FaSearch, FaTrash, FaFilter, FaChevronUp } from 'react-icons/fa';
import { SlRefresh } from "react-icons/sl";
import { RiFileExcel2Line } from "react-icons/ri";
import Toggle from "../Toggle/Toggle";
import DateRangePicker from "../DateRangePicker/DateRangePicker";
import './Search.css';

const Search = ({
  search,
  formFields,
  title,
  excel = null,
  setParamsaa = null
}) => {
  const [formData, setFormData] = useState({})
  const [options, setOptions] = useState({});
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const session = useSelector((state) => state.session.data);
  const { request } = useApiSelect();
  const resetFormData = () =>{
    setFormData({})
  }

  const formatForDisplay = (raw) => {
    if (raw == null) return "";
    const s = String(raw);
    if (s === "" || s === "-" || s === "." || s === "-.") return s;
    const noComma = s.replace(/,/g, "");
    const neg = noComma.startsWith("-");
    const body = neg ? noComma.slice(1) : noComma;

    const hasDot = body.includes(".");
    const [intPartRaw, fracPartRaw = ""] = body.split(".");
    const intPart = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const out =
      (neg ? "-" : "") +
      intPart +
      (hasDot ? "." + fracPartRaw : "");

    return out;
  };

  const numericLike = (s) => /^-?\d*(\.\d*)?$/.test(s);

  useEffect(() => {
    const fetchOptions = async () => {
      const newOptions = {};
      for (const field of formFields) {
        if (field.type === "apiSelect" && field.apiKey && request[field.apiKey]) {
          const response = await request[field.apiKey]({ companySeq: session.companySeq });
          newOptions[field.key] = response.map((item) => ({
            label: item[field.labelKey],
            value: item[field.valueKey],
          }));
        }
      }
      setOptions(newOptions);
    };
    fetchOptions();
  }, [formFields]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const searchContents = () => {
    const payload = { ...formData, companySeq: session.companySeq };

  if (typeof setParamsaa === "function") {
    setParamsaa(payload);
  }
    formData.companySeq = session.companySeq;
    search(formData)
  }

  const downloadExcel = () => {
    formData.companySeq = session.companySeq;
    console.log('여기옴')
    excel(null, 2, formData)
  }
  return (
    <div className="search-container">
      <div className="search-header-container">
        <h3 className="search-title">
          <span className="title-with-icon">
            <FaSearch className="icon" />
            {title} 검색
          </span>
        </h3>
        <div className="controls">
          <div className="buttons">
            <button
              className="filter-toggle-btn"
              onClick={() => setIsFilterOpen(!isFilterOpen)}
            >
              {isFilterOpen ? <FaChevronUp className="button-icon" /> : <FaFilter className="button-icon" />}
              {isFilterOpen ? '접기' : '필터'}
            </button>
            {excel &&
              <button className="excel-button search-title" onClick={() => { downloadExcel() }}>
                <span className='title-with-icon'>
                  <RiFileExcel2Line className="button-icon" /> Excel 다운로드
                </span>

              </button>
            }
            <button className="refresh-button" onClick={() => { resetFormData() }}>
              <SlRefresh className="button-icon" /> 초기화
            </button>
            <button className="search-button" onClick={() => searchContents()}>
              <FaSearch className="button-icon" /> 검색
            </button>
          </div>
        </div>
      </div>
      <div className={`search-form ${isFilterOpen ? 'search-form-open' : ''}`}>
        {formFields.filter((input) => input.visible !== false).map((input, index) => (
          <div key={index} className={`search-field ${input.type === 'dateRangeSelect' || (input.type === 'dateRange' && input.split) ? 'search-field-date' : ''}`}>
            {input.type === "dateRangeSelect" ? (
              <div className="drp-select-group">
                <label className="search-label">{input.label}</label>
                <div className="drp-select-body">
                  <select
                    name={input.key}
                    className="search-input search-select"
                    value={formData[input.key] || input.dateOptions[0].value}
                    onChange={(e) => {
                      const prev = formData[input.key] || input.dateOptions[0].value;
                      const prevOpt = input.dateOptions.find(o => o.value === prev);
                      const nextOpt = input.dateOptions.find(o => o.value === e.target.value);
                      const startVal = formData[prevOpt.startKey] || '';
                      const endVal = formData[prevOpt.endKey] || '';
                      setFormData(fd => {
                        const updated = { ...fd, [input.key]: e.target.value };
                        if (prevOpt) { updated[prevOpt.startKey] = ''; updated[prevOpt.endKey] = ''; }
                        if (startVal) updated[nextOpt.startKey] = startVal;
                        if (endVal) updated[nextOpt.endKey] = endVal;
                        return updated;
                      });
                    }}
                  >
                    {input.dateOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                  {(() => {
                    const selected = input.dateOptions.find(o => o.value === (formData[input.key] || input.dateOptions[0].value));
                    return (
                      <DateRangePicker
                        label=""
                        startKey={selected.startKey}
                        endKey={selected.endKey}
                        formData={formData}
                        setFormData={setFormData}
                        split
                      />
                    );
                  })()}
                </div>
              </div>
            ) : input.type === "apiSelect" ? (
              <div className="search-field-inner">
                <label htmlFor={input.key} className="search-label">{input.label}</label>
                <select
                  name={input.key}
                  id={input.key}
                  className="search-input search-select"
                  value={formData[input.key] || ""}
                  onChange={handleChange}
                >
                  <option value="">전체</option>
                  {options[input.key]?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            ) : input.type === "checkbox" ? (
              <div className="search-field-inner">
                <label className="search-label">{input.label}</label>
                <div className="search-toggle-wrap">
                  <Toggle
                    isOn={ (formData[input.key] ?? (input.default ?? input.defaultValue ?? true)) }
                    handleToggle={() => {
                      setFormData(prev => {
                        const fallback = (input.default ?? input.defaultValue ?? true);
                        const current = (prev[input.key] ?? fallback);
                        return { ...prev, [input.key]: !current };
                      });
                    }}
                    onText={input.onText}
                    offText={input.offText}
                  />
                </div>
              </div>
            ) : input.type === "select" ? (
              <div className="search-field-inner">
                <label htmlFor={input.key} className="search-label">{input.label}</label>
                <select
                  name={input.key}
                  id={input.key}
                  className="search-input search-select"
                  value={formData[input.key] || ""}
                  onChange={handleChange}
                >
                  <option value="" disabled hidden></option>
                  {input.options?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            ) : input.type === "dateRange" ? (
              input.split ? (
                <div className="search-field-inner">
                  <label className="search-label">{input.label}</label>
                  <DateRangePicker
                    label=""
                    startKey={input.startKey}
                    endKey={input.endKey}
                    formData={formData}
                    setFormData={setFormData}
                    split
                  />
                </div>
              ) : (
                <DateRangePicker
                  label={input.label}
                  startKey={input.startKey}
                  endKey={input.endKey}
                  formData={formData}
                  setFormData={setFormData}
                />
              )
            ) : input.type === "date" ? (
              <div className="search-field-inner">
                <label htmlFor={input.key} className="search-label">{input.label}</label>
                <input
                  type="date"
                  name={input.key}
                  id={input.key}
                  value={formData[input.key] || ""}
                  onChange={handleChange}
                  required={input.required}
                  className="search-input"
                />
              </div>
            ) : input.type === "number" ? (
              <div className="search-field-inner">
                <label htmlFor={input.key} className="search-label">{input.label}</label>
                <input
                  type="text"
                  name={input.key}
                  id={input.key}
                  value={formatForDisplay(formData[input.key] ?? "")}
                  onChange={(e) => {
                    const entered = e.target.value;
                    const raw = entered.replace(/,/g, "");
                    if (!numericLike(raw)) return;
                    setFormData((prev) => ({ ...prev, [input.key]: raw }));
                  }}
                  required={input.required}
                  placeholder=" "
                  className="search-input"
                />
              </div>
            ): (
              <div className="search-field-inner">
                <label htmlFor={input.key} className="search-label">{input.label}</label>
                <input
                  type={input.type}
                  name={input.key}
                  id={input.key}
                  value={formData[input.key] || ""}
                  onChange={handleChange}
                  required={input.required}
                  placeholder=" "
                  className="search-input"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Search;
